<template>
  <img v-stat.brow.click="{ tag: 'c2c.entry' }"  class="c2c-entry" :src="url" @click="onClick" />
</template>

<script lang="ts" setup>
defineProps<{
  url: string;
}>();
const emits = defineEmits(['onClick']);

function onClick() {
  emits('onClick');
}
</script>

<style lang="less" scoped>
@import (reference) '~@/less/main';
.c2c-entry {
  width: 100%;
  display: block;
}
</style>
